export default "__VITE_ASSET__DuRt7MD6__"